import React from "react";
import { ProfileRow } from "../ProfileRow";
import { renderValue } from "../renderValueHelper";
import { useTranslation } from "@helpers/translate";
import changeIcon from "@assets/images/icons/change-icon.svg";
import saveIcon from "@assets/images/icons/save-icon.svg";
import cancelIcon from "@assets/images/icons/cancel-icon.svg";

import "./index.sass";

export const NicknameRow = ({
  nickname,
  editingField,
  editingValues,
  setEditingValues,
  nicknameInputRef,
  handleSaveField,
  setEditingField,
  savingField,
}) => {
  const { __ } = useTranslation();

  const cancelEditing = () => {
    setEditingField(null);

    setEditingValues((prev) => ({
      ...prev,
      nickname: nickname || "",
    }));
  };

  const value =
    editingField === "nickname" ? (
      <input
        ref={nicknameInputRef}
        type="text"
        className="profile-row__editable-input"
        value={editingValues.nickname || ""}
        onChange={(event) => {
          setEditingValues((prev) => ({
            ...prev,
            nickname: event.target.value,
          }));
        }}
        onBlur={(event) => {
          if (!event.target.value.trim()) {
            setEditingValues((prev) => ({
              ...prev,
              nickname: nickname || "",
            }));
          }
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();

            handleSaveField(
              "nickname",
              editingValues.nickname,
            );
          }

          if (event.key === "Escape") {
            cancelEditing();
          }
        }}
        placeholder={
          __("profile.nickname") || "Nickname"
        }
      />
    ) : (
      renderValue(nickname)
    );

  const actions =
    editingField === "nickname" ? (
      <>
        <button
          type="button"
          onClick={() =>
            handleSaveField(
              "nickname",
              editingValues.nickname,
            )
          }
          disabled={savingField === "nickname"}
          className="profile-action__save profile-action__button"
        >
          <img src={saveIcon} alt="save" />
        </button>

        <button
          type="button"
          onClick={cancelEditing}
          disabled={savingField === "nickname"}
          className="profile-action__cancel profile-action__button"
        >
          <img src={cancelIcon} alt="cancel" />
        </button>
      </>
    ) : (
      <button
        type="button"
        className="profile-action__button"
        onClick={() => {
          setEditingField("nickname");

          setEditingValues((prev) => ({
            ...prev,
            nickname: nickname || "",
          }));
        }}
      >
        <img src={changeIcon} alt="change" />
      </button>
    );

  return (
    <ProfileRow
      label={__("profile.nickname")}
      value={value}
      actions={actions}
    />
  );
};
